import { useMemo } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2"; // أيقونات تقنية حادة
import { Link, useLocation } from "react-router-dom";
import sitemap from "config/siteMap.json";
import { VscFolderActive } from "react-icons/vsc"; // أيقونة مجلد تقنية

export default function BreadcrumbContext() {
  const location = useLocation();

  const locationLine = useMemo(
    () => findMatchingObjects(location.pathname),
    [location.pathname]
  );

  return (
    <nav className="flex items-center mb-4 select-none" dir="rtl">
      <div className="flex items-center bg-white dark:bg-gray-800 px-3 py-1.5 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm transition-all overflow-hidden">
        {/* أيقونة ثابتة في البداية تعطي هوية للنظام */}
        <div className="flex items-center justify-center text-blue-600 dark:text-blue-500 ml-2">
          <VscFolderActive size={16} />
        </div>

        {locationLine.length > 0
          ? locationLine.map((item, index) => {
              const isLast = index === locationLine.length - 1;

              return (
                <div className="flex items-center" key={index}>
                  <Link
                    to={item.url}
                    className={`text-[11px] font-bold uppercase tracking-tight px-2 py-0.5 rounded-md transition-all
                    ${
                      isLast
                        ? "text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-700 pointer-events-none"
                        : "text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400"
                    }`}
                  >
                    {item.title}
                  </Link>

                  {!isLast && (
                    <span className="text-gray-300 dark:text-gray-600 flex items-center">
                      {document.documentElement.lang === "ar" ? (
                        <HiChevronLeft size={14} strokeWidth={2} />
                      ) : (
                        <HiChevronRight size={14} strokeWidth={2} />
                      )}
                    </span>
                  )}
                </div>
              );
            })
          : null}
      </div>
    </nav>
  );
}

// الدوال المساعدة تبقى كما هي
function removeParts(textUrl) {
  const resultArray = [];
  resultArray.push(textUrl);
  let remainingText = textUrl;
  while (remainingText.includes("/")) {
    const index = remainingText.lastIndexOf("/");
    remainingText = remainingText.substring(0, index);
    resultArray.push(remainingText);
  }
  return resultArray.reverse();
}

function findMatchingObjects(mainLocation) {
  let afterRemoveParts = removeParts(mainLocation);
  const resultArray = [];
  for (let part of afterRemoveParts) {
    sitemap.forEach((obj) => {
      if (obj.url === part) {
        resultArray.push(obj);
      }
    });
  }
  return resultArray;
}
